import iView from 'iview'
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import web from './modules/web'
import admin from './modules/admin'
import manage from './modules/manage'
import root from './modules/root'
import cms from './modules/cms'
import wechat from './modules/wechat'

Vue.use(VueRouter)
Vue.use(iView)

const routes = [].concat(web, admin, manage, cms, wechat, root)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  // 修改如果打开的菜单有标题，则修改标题
  document.title = (to.meta.name) ? `${store.state.name} -- ${to.meta.name}` : store.state.name

  if (to.matched.some(r => r.meta.requireAuth)) {
    if (store.state.AuthStore.jwtToken) {
      next()
    } else {
      next({
        name: 'auth.login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  iView.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js